
import { ActionSheet, Loading } from 'vant'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useCommonStudyListEffect } from '@/effects/quesListEffect'

// 处理跳转相关逻辑
const useJumpEffect = () => {
  const show = ref(false)
  const router = useRouter()
  const route = useRoute()

  const store = useStore()
  const list = ref(store.getters.getStudyQuesList)

  const { getStudyList, partLoading } = useCommonStudyListEffect(list)

  const handleJumpClick = async index => {
    console.log('list.value', list.value)
    if (!list.value[index]) {
      await getStudyList(index + 1)
    }
    show.value = false
    router.replace({
      path: `/single/${index + 1}`,
      query: route.query
    })
  }

  return {
    show,
    partLoading,
    handleJumpClick
  }
}

export default {
  props: {
    id: {
      type: Number,
      default: 1
    }
  },
  components: { ActionSheet, Loading },
  setup(props) {
    const { show, handleJumpClick, partLoading } = useJumpEffect()

    return {
      show,
      partLoading,
      handleJumpClick
    }
  }
}
